import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { map, Observable } from 'rxjs';
import { SelectOption } from '../../../models';
import { AutocompleteInput } from '../../../models/inputs/autocomplete-input';
import { AddClearOptionPipe } from '../../../pipes';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-autocomplete-input',
    standalone: true,
    imports: [AutoCompleteModule, FormsModule, ReactiveFormsModule, AsyncPipe, AddClearOptionPipe, TranslateModule],
    template: `
        <p-autoComplete
            inputId="{{ 'input-' + name }}"
            [class]="control.inputClass.join(' ')"
            [placeholder]="control.placeholder! | translate"
            [formControl]="control"
            [dropdown]="true"
            [suggestions]="(filteredValue$ | async) ?? [] | addClearOption : control.clearable!"
            field="label"
            [multiple]="!!control.multiple"
            [minLength]="control.minTermLength!"
            (completeMethod)="onSearch($event)"
        ></p-autoComplete>
    `
})
export class AutocompleteInputComponent<T = string, E = string> extends BaseInputComponent<T> implements OnInit {
    @Input() name!: string;
    @Input() override control!: AutocompleteInput<T, E>;
    filteredValue$: Observable<SelectOption<T, E>[]> | undefined;

    ngOnInit() {
        this.filteredValue$ = this.control.options;
    }

    onSearch(searchText: { query: string }) {
        const { query } = searchText;
        if (this.control.typeaheadMethod) {
            this.filteredValue$ = this.control.typeaheadMethod(query);
        } else {
            this.filteredValue$ = this.control.options?.pipe(
                map((availableOptions) => {
                    const filtered = availableOptions.filter((option) =>
                        (option.label as string).toLowerCase().includes(query.toLowerCase())
                    );
                    return filtered;
                })
            );
        }
    }
}
